import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";

// Self-hosted Inter Variable (full + italic). Bundled by Vite — no CDN.
import "@fontsource-variable/inter";
import "@fontsource-variable/inter/wght-italic.css";

import { App } from "@/App";
import { queryClient } from "@/lib/queryClient";
import { registerServiceWorker } from "@/lib/registerSW";
import { useAuthStore } from "@/store/auth";
import "./index.css";

registerServiceWorker();

// Kick off auth hydration before React mounts so the first render already
// has either an authed session or a definitive 'unauthed' status (after
// the brief AuthLoading splash). Idempotent.
void useAuthStore.getState().init();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            success: { className: "!bg-emerald-600 !text-white" },
            error: { className: "!bg-rose-600 !text-white" },
          }}
        />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
